import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Box,
  Box as IconCol,
  Box as IconCircle,
  Box as Body,
  Button,
  Icon,
  Text,
} from '@node-space/storybook-components'
import { Description } from 'components/Text'

export const PendingNotification = () => {
  const { t } = useTranslation()

  return (
    <Box
      background="white"
      border="gray"
      borderRadius={8}
      paddingY={24}
      gapX={24}
      paddingX={32}
      className="relative xs:flex"
    >
      <IconCol flex justifyContent="center" className="xs:justify-start">
        <IconCircle flex borderRadius="full" size={48} centerChildren background="info">
          <Icon name="ClockCounterClockwiseIcon" color="secondary-500" size="lg" />
        </IconCircle>
      </IconCol>
      <Body flex direction="col" paddingT={12} gapY={12}>
        <Text tag="h2" size="lg" weight="medium">
          {t('verification.pendingHeading')}
        </Text>
        <Description>{t('verification.pendingSubHeading1')}</Description>
        <Description>{t('verification.pendingSubHeading2')}</Description>
        <Box>
          <Button
            onClick={() => window.open(process.env.SUPPORT_URL)}
            iconElement={<Icon name="ExternalLinkIcon" color="white" />}
            iconRight
            className="mt-1"
          >
            {t('contactSupport')}
          </Button>
        </Box>
      </Body>
    </Box>
  )
}
